export function Ico16Check({ ...props }) {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M2 6.625L6.69565 11L14 4" stroke="#9BADBF" strokeWidth="2" />
    </svg>
  );
}
